export type FacetVariant = 'horizontal' | 'sidebar' | 'drawer' | 'mobile';

/**
 * The mobile drawer mounts the same facets as the breakpoint-hidden sidebar
 * and horizontal bar, so its TreeAccordion checkboxes need their own id
 * namespace: with a shared one, a drawer `<label htmlFor>` resolves to the
 * desktop instance and the drawer's own checkbox is left unnamed.
 */
export const getFacetTreeIdPrefix = (variant: FacetVariant) =>
  variant === 'mobile' ? 'tree-mobile' : undefined;
